var exports = {
  "n": "x31de4314--4201ee--row",
};

module.exports = exports;
